import { render, staticRenderFns } from "./meeting.vue?vue&type=template&id=1de8dc16&scoped=true&"
import script from "./meeting.vue?vue&type=script&lang=js&"
export * from "./meeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de8dc16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de8dc16')) {
      api.createRecord('1de8dc16', component.options)
    } else {
      api.reload('1de8dc16', component.options)
    }
    module.hot.accept("./meeting.vue?vue&type=template&id=1de8dc16&scoped=true&", function () {
      api.rerender('1de8dc16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/meeting.vue"
export default component.exports